"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _appLogo = _interopRequireDefault(require("../images/app-logo.png"));

var _PoweredByVitusPayModule = _interopRequireDefault(require("./PoweredByVitusPay.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules
// Images
// Styles
var PoweredByVitusPay = function PoweredByVitusPay() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _PoweredByVitusPayModule.default.container
  }, /*#__PURE__*/_react.default.createElement("p", null, "Powered By"), /*#__PURE__*/_react.default.createElement("img", {
    src: _appLogo.default,
    alt: "VitusPay"
  }));
};

var _default = PoweredByVitusPay;
exports.default = _default;